export const RoleEnums = {
  // Роли пользователей
  ADMIN: 1,
  OPERATOR: 2,
  CONTENT_MANAGER: 3,
  USER: 4,
  CONTROLLER: 5,
  MODERATOR: 6,
};

export const OrderStatusEnums = {
  // Статусы заявки
  NEW: 1,
  IN_PROGRESS: 2,
  APPROVED: 3,
  RESERVE: 4,
  REJECTED: 5,
  CLOSED: 6,
  CANCELED: 7,
  EVENT_ATTENDED: 8,
};
